import { unreachable } from '../utils/unreachable';

export enum Confidence {
  Green = 0,
  Amber = 1,
  Red = 2,
}

export function getConfidenceLabel(status: Confidence, t: (key: string) => string): string {
  switch (status) {
    case Confidence.Green:
      return t('Green');
    case Confidence.Amber:
      return t('Amber');
    case Confidence.Red:
      return t('Red');
    default:
      return unreachable(status);
  }
}
